import { Suspense } from "react";

import "./app.css";
import { AuthProvider } from "@hl/shared-features/lib/features/auth";
import {
  FEATURE_FLAGS,
  useBootstrap,
  useFeatureFlags,
} from "@hl/shared-features/lib/features/auth/hooks";
import { createWagmiClient } from "@hl/shared-features/lib/features/eth/client";
import TransactionProvider from "@hl/shared-features/lib/features/evm-tx/TransactionProvider";
import { NotFound } from "@hl/shared-features/lib/features/layout/NotFound";
import MarketplaceProvider from "@hl/shared-features/lib/features/marketplace/provider";
import { ModalStack } from "@hl/shared-features/lib/features/modal";
import loadable from "@loadable/component";
import { Route, Routes } from "react-router-dom";
import { WagmiConfig } from "wagmi";

import { MINT_URL, TOOLS_URL } from "./config";
import MintPageByCollectionId from "./features/MintPage/MintPageByCollectionId";
import MintPageByContractAddress from "./features/MintPage/MintPageByContractAddress";
import MintPageByOnChainId from "./features/MintPage/MintPageByOnChainId";
import TokenMetadata from "./features/MintPage/TokenMetadata";
import TokenReveal from "./features/MintPage/token-reveal/TokenReveal";
import { HomePage } from "./features/home";
import Root from "./features/layout/Root";
import MarketplacePage from "./features/marketplace/MarketplacePage";
import { PortfolioPublic } from "./features/portfolio/PortfolioPublic";

const TokenDetails = loadable(
  () => import("./features/token-details/TokenDetails")
);
const BrowsePage = loadable(() => import("./features/browse/BrowsePage"));

const { wagmiClient } = createWagmiClient({ appName: "Highlight Mint" });

export const App = () => {
  useBootstrap();

  const enableMarketplace = useFeatureFlags(
    FEATURE_FLAGS.MARKETPLACE_ALL_FEATURES
  );

  return (
    <Suspense fallback={""}>
      <WagmiConfig config={wagmiClient}>
        <AuthProvider>
          <TransactionProvider>
            <MarketplaceProvider>
              <ModalStack>
                <Root>
                  <Routes>
                    <Route
                      path={MINT_URL.portfolio.public}
                      element={<PortfolioPublic />}
                    />
                    <Route
                      path={MINT_URL.portfolio.publicItem}
                      element={<PortfolioPublic />}
                    />
                    <Route path="/" element={<HomePage />} />
                    <Route
                      path={MINT_URL.tokens.mint}
                      element={<MintPageByCollectionId />}
                    />
                    <Route
                      path={MINT_URL.tokens.mintByAddress}
                      element={<MintPageByContractAddress />}
                    />
                    <Route
                      path={MINT_URL.tokens.mintByOnChainId}
                      element={<MintPageByOnChainId />}
                    />
                    <Route
                      path={MINT_URL.tokens.metadata}
                      element={<TokenMetadata />}
                    />
                    <Route
                      path={MINT_URL.tokens.browse}
                      element={<BrowsePage />}
                    />
                    {enableMarketplace && (
                      <Route
                        path={MINT_URL.tokens.marketplace}
                        element={<MarketplacePage />}
                      />
                    )}
                    <Route
                      path={MINT_URL.tokens.detail}
                      element={<TokenDetails />}
                    />
                    <Route
                      path={MINT_URL.tokens.reveal}
                      element={<TokenReveal />}
                    />
                    <Route
                      path={"*"}
                      element={<NotFound redirectUrl={TOOLS_URL.base} />}
                    />
                  </Routes>
                </Root>
              </ModalStack>
            </MarketplaceProvider>
          </TransactionProvider>
        </AuthProvider>
      </WagmiConfig>
    </Suspense>
  );
};
